<template>
  <div class="q-mt-xl">
    <div
      class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
      style="font-size: 16px"
    >
      <span> Pedidos de Compra em Aberto para essa Necessidade </span>
      <div class="row q-gutter-sm">
        <q-btn
          label="Criar Novo"
          icon="add"
          style="border-radius: 8px; background-color: #304f78; color: white"
          no-caps
          v-if="!manual"
          @click="rightDrawerOpen = true"
        />
        <q-btn
          class="q-ml-sm"
          icon="close"
          color="negative"
          style="border-radius: 8px; background-color: #304f78; color: white"
          label="Voltar"
          v-if="manual"
          @click="manual = false"
        />
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filter"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search"></q-icon>
          </template>
        </q-input>
      </div>
    </div>

    <dialog-info-design
      mensagem="Tem certeza que deseja excluir o Fornecedor?"
      :exibir="confirm"
      :desabilitarConfirme="false"
      @resultado="incluir"
    >
      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="produtos"
        dense
        class="tabela-tamanho-fixo"
        :columns="columnsModal"
        :loading="disable"
        hide-pagination
        v-model:pagination="pagination"
        :filter="filter"
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template #body-cell-previsao="props">
          <q-td>
            <q-input
              style="max-width: 200px"
              v-model="props.row.receipt_date_forecast"
              dense
              label="Digite a previsão"
              outlined
              class="input"
              placeholder="DD/MM/AAAA"
              mask="##/##/####"
              v-if="props"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="props.row.receipt_date_forecast"
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </q-td>
        </template>
      </q-table>
    </dialog-info-design>

    <q-table
      v-if="manual == false"
      flat
      table-header-style="background-color: #d9effc"
      :rows="rows"
      dense
      class="tabela-tamanho-fixo"
      :columns="columns"
      :loading="disable"
      hide-pagination
      v-model:pagination="pagination"
      :filter="filter"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template #body-cell-id="props">
        <q-td>
          <router-link
            style="cursor: pointer; font-weight: bolder"
            class="text-info"
            type="a"
            :to="{ name: 'compras-editar', params: { id: props.row.id } }"
            target="_blank"
          >
            {{ props.row.id }}</router-link
          >
        </q-td>
      </template>
      <template #body-cell-incluir="props">
        <q-td>
          <q-btn
            @click="
              (saveRow = props.row.id),
                (saveForecastOld = props.row.receipt_date_forecast),
                props.row.receipt_date_forecast == null ||
                props.row.receipt_date_forecast == ''
                  ? (produtos = produtos.map((e) => {
                      return {
                        ...e,
                        receipt_date_forecast: ''
                          .split(' ')[0]
                          .split('-')
                          .reverse()
                          .join('/'),
                      };
                    }))
                  : (produtos = produtos.map((e) => {
                      return {
                        ...e,
                        receipt_date_forecast: props.row.receipt_date_forecast
                          .split(' ')[0]
                          .split('-')
                          .reverse()
                          .join('/'),
                      };
                    })),
                (confirm = true)
            "
            icon="sym_o_add"
            round
            flat
            color="positive"
            :disable="produtos.length == 0"
          />
        </q-td>
      </template>

      <template #body-cell-produtosNumero="props">
        <q-td>
          {{ props.row.products.length }}
        </q-td>
      </template>
    </q-table>

    <div v-if="manual == false" class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>

    <criar-novo v-if="manual" @voltar="voltar" />
    <ModalInformacaoesAdicionais
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Criar Novo Pedido'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Unidade</div>

          <lista-unidades-select v-model="unidade"></lista-unidades-select>
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Urgencia</div>

          <q-select
            dense
            outlined
            :options="urgenciaOptions"
            option-label="label"
            option-value="value"
            map-options
            emit-value
            v-model="urgenciaValue"
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Fornecedor</div>

          <q-select
            dense
            outlined
            :options="fornecedoresOptions"
            option-label="business_name"
            option-value="id"
            map-options
            emit-value
            @filter="filtrarFornecedores"
            use-input
            v-model="fornecedorValue"
          >
            <template v-slot:option="scope">
              <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                <q-item-section>
                  <q-item-label
                    class="text-weight-bold"
                    style="font-size: 14px"
                  >
                    {{ scope.opt.business_name }}
                  </q-item-label>
                  <q-item-label
                    caption
                    class="text-grey-6"
                    style="font-size: 12px"
                  >
                    {{ scope.opt.business_name }} -
                    {{ formatarCnpj(scope.opt.cnpj) }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
        <div
          v-if="
            $store.state.autenticacao.cliente.includes('acciona') ||
            $store.state.autenticacao.cliente.includes('staging-acciona')
          "
          class="col-md-2 col-xs-6 col-sm-6"
        >
          <div class="q-ml-sm texto-titulo-input">
            Aprovadores Pre-Selecionados
          </div>
          <q-select
            dense
            outlined
            :options="solicitantesOptionsPre"
            option-label="name"
            map-options
            multiple
            emit-value
            v-model="solicitantesValuePre"
          >
          </q-select>
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Aprovador</div>

          <q-select
            dense
            outlined
            :options="solicitantesOptions"
            option-label="name"
            map-options
            @filter="filtrarSolicitante"
            use-input
            multiple
            emit-value
            v-model="solicitantesValue"
          >
          </q-select>
        </div>

        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">
            Aprovadores Sequencia Final
          </div>
          <q-select
            dense
            outlined
            :options="solicitantesOptionsFinal"
            option-label="name"
            map-options
            multiple
            emit-value
            v-model="solicitantesValueFinal"
            disabled
          >
            <template v-slot:selected-item="scope">
              <div
                class="hover-select"
                style="height: 48px; cursor: pointer; padding: 8px 16px"
                v-bind="scope.itemProps"
                v-on="scope.itemEvents"
              >
                {{ scope.index + 1 }} - {{ scope.opt.name }}
              </div>
            </template>
          </q-select>
        </div>
        <div
          v-if="
            !$store.state.autenticacao.cliente.includes('acciona') &&
            !$store.state.autenticacao.cliente.includes('staging-acciona')
          "
          class="col-md-2 col-xs-6 col-sm-6"
        >
          <div class="q-ml-sm texto-titulo-input">Previsão de Faturamento</div>
          <q-input dense outlined v-model="faturamento">
            <template v-slot:append>
              <q-icon
                color="brand-1"
                name="sym_o_calendar_month"
                class="cursor-pointer"
              >
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="faturamento"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Previsão de Recebimento</div>
          <q-input
            dense
            outlined
            v-model="recebimento"
            mask="##/##/####"
            :rules="[(val) => !!val || 'Este campo é obrigatório']"
          >
            <template v-slot:append>
              <q-icon
                color="brand-1"
                name="sym_o_calendar_month"
                class="cursor-pointer"
              >
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="recebimento"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </template>
      <template v-slot:botao-modal>
        <div class="row col-12 q-gutter-sm">
          <q-btn
            no-caps
            label="Criar Pedido"
            class="btn-modal"
            icon="add"
            @click="criarPedido"
            :disable="!recebimento"
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
          />
        </div>
      </template>
    </ModalInformacaoesAdicionais>
  </div>
</template>

<script>
// funcao auxiliar: determina o numero de casas decimais necessarias (min 2, max 4)
const getDecimalPlaces = (num) => {
  const str = num.toString();
  const dotIndex = str.indexOf(".");
  if (dotIndex === -1) return 2;
  const decimals = str.slice(dotIndex + 1).replace(/0+$/, "");
  return Math.min(Math.max(decimals.length, 2), 4);
};

const parseValor = (value) => {
  if (value === null || value === undefined || value === "") return NaN;
  const str = String(value).trim();
  if (str.includes(",") && str.includes(".")) {
    return parseFloat(str.replace(/\./g, "").replace(",", "."));
  }
  if (str.includes(",")) {
    return parseFloat(str.replace(",", "."));
  }
  return parseFloat(str);
};

// funçao para formatar preço (R$ com minimo 2 casas decimais, maximo 4)
const formatPreco = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  const num = Number(String(value).replace(",", "."));
  if (isNaN(num)) return "R$ 0,00";

  const decimalPlaces = getDecimalPlaces(num);

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(num);
};

const columns = [
  {
    name: "name",
    label: "Unidade",
    field: (row) => row?.vendor?.name,
    align: "left",
  },
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "fornecedor",
    label: "Fornecedor",
    field: (row) => row?.provider?.business_name,
    align: "left",
  },
  {
    name: "previsao",
    label: "Previsão de Recebimento	",
    field: (row) =>
      row.receipt_date_forecast != null
        ? row.receipt_date_forecast.split(" ")[0].split("-").reverse().join("/")
        : "Sem data",
    align: "left",
  },
  {
    name: "total",
    label: "Total da Ordem	",
    field: (row) => formatPreco(row.total_produtos),
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: (row) => row.status,
    align: "left",
  },
  {
    name: "aprovacao",
    label: "Aprovação",
    field: (row) => row.aprovacao,
    align: "left",
  },
  {
    name: "produtosNumero",
    label: "Nº de itens no pedido	",
    field: "produtosNumero",
    align: "left",
  },
  {
    name: "incluir",
    label: "Incluir Produtos	",
    field: (row) => row.aprovacao,
    align: "left",
  },
];

const columnsModal = [
  {
    name: "produto_nome",
    label: "Descrição",
    field: "produto_nome",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "product_codigo",
    label: "Código",
    field: "product_codigo",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "previsao",
    label: "Previsão de entrega",
    field: "previsao",
    align: "center",
    style: "white-space: normal",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import CriarNovo from "./CriarNovo.vue";
import ModalInformacaoesAdicionais from "../components/ModalInformacaoesAdicionais.vue";
import DialogInfoDesign from "./DialogInfoDesign.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: {
    CriarNovo,
    ModalInformacaoesAdicionais,
    DialogInfoDesign,
    ListaUnidadesSelect,
  },
  props: ["selecionados"],
  setup(props, { emit }) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const produtos = ref([]);
    const filter = ref("");
    const manual = ref(false);
    const disableIncluir = ref(false);
    const fornecedorValue = ref(null);
    const fornecedoresOptions = ref([]);
    const solicitantesOptions = ref([]);
    const unidade = ref();
    const solicitantesOptionsPre = ref([
      { name: "ANA PAULA BORTOLOTI ARAUJO", id: 2859 },
      { name: "FELIPE SANTOS DA SILVA", id: 18 },
      { name: "JEFFERSON LUIZ AUGUSTO", id: 12 },
      { name: "BRUNO LISBOA AULETTA", id: 7 },
      { name: "FERNANDO WINKLER MORAIS DE CASTRO", id: 11 },
      { name: "CLAUDIONOR SANTANA DA SILVA", id: 15 },
      { name: "EDGLEICE DE VASCONCELOS", id: 16 },
      { name: "DAVID ALCARAZ CHICO DE GUZMAN", id: 700 },
    ]);

    const solicitantesOptionsFinal = ref([]);
    const solicitantesValue = ref([]);
    const solicitantesValueFinal = ref([]);
    const solicitantesValuePre = ref([]);
    const urgenciaValue = ref("");
    const rightDrawerOpen = ref(false);
    const faturamento = ref("");
    const confirm = ref(false);
    const saveRow = ref(null);
    const time = ref(null);
    const saveForecast = ref(null);
    const saveForecastOld = ref(null);
    const recebimento = ref("");
    const erroRecebimento = ref(false);

    const saveForecastFormatado = computed(() =>
      saveForecast.value?.split(" ")[0].split("-").reverse().join("/")
    );

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 5,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 5) => {
      try {
        const response = await store.dispatch("compras/purchaseDetalhes", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          provider: filter.value,
        });

        rows.value = response.data.results.data;

        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const validarPrecos = () => {
      if (produtos.value.length === 0) {
        disableIncluir.value = false;
        return true;
      }

      const produtosSemPreco = produtos.value.filter((produto) => {
        const preco = produto.purchase_order_price || produto.price;
        return (
          !preco ||
          preco.toString().trim() === "" ||
          preco.toString().replace(/[,.\s]/g, "") === "" ||
          parseValor(preco.toString()) <= 0
        );
      });

      const todosTemPreco = produtosSemPreco.length === 0;

      disableIncluir.value = !todosTemPreco;

      return todosTemPreco;
    };

    const incluir = async (resultado) => {
      confirm.value = false;
      if (resultado) {
        // validar se há produtos sem responsavel
        const produtosSemResponsavel = produtos.value.filter((produto) => {
          return !produto.matricula_responsavel && !produto.responsavel_nome;
        });

        if (produtosSemResponsavel.length > 0) {
          $q.notify({
            message:
              "Não é possível incluir um produto sem responsável no Pedido",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        if (!validarPrecos()) {
          const produtosSemPreco = produtos.value.filter((produto) => {
            const preco = produto.purchase_order_price || produto.price;
            return (
              !preco ||
              preco.toString().trim() === "" ||
              preco.toString().replace(/[,\s]/g, "") === "" ||
              parseFloat(preco.toString().replace(",", ".")) <= 0
            );
          });

          $q.notify({
            message: `Existem ${produtosSemPreco.length} produto(s) sem preço informado. Preencha todos os preços antes de incluir.`,
            color: "negative",
            timeout: 3000,
          });

          setTimeout(() => {
            disableIncluir.value = false;
          }, 100);

          return;
        }

        try {
          disableIncluir.value = true;

          let produtosArray = [];

          produtos.value.forEach((e) => {
            produtosArray.push({
              id: e.product_id,
              necessidade_compra_uuid: e.uuid_item,
              amount: e.quantidade_necessaria,
              price:
                e.purchase_order_price == null
                  ? parseValor(String(e.price))
                  : e.purchase_order_price,
              previsao_inicial_entrega:
                saveForecastOld?.value?.split(" ")[0] != undefined
                  ? saveForecastOld?.value?.split(" ")[0]
                  : e.receipt_date_forecast,
              previsao_atualizada_entrega: e?.receipt_date_forecast
                .split("/")
                .reverse()
                .join("-"),
            });
          });

          await store.dispatch("compras/incluirProduto", {
            purchase_id: saveRow.value,
            products: produtosArray,
          });

          $q.notify({
            message: "Incluído com sucesso",
            color: "positive",
            timeout: 3000,
          });

          getDados();
          emit("atualizar");
          emit("limpar-selecao");

          produtos.value.forEach((produto) => {
            produto.selected = false;
          });

          disableIncluir.value = false;
        } catch (error) {
          disableIncluir.value = false;

          console.error("Erro ao incluir produto:", error);

          let mensagemErro = "Erro ao incluir produto. ";

          if (error?.response?.data?.message) {
            mensagemErro += error.response.data.message;
          } else if (error?.response?.status === 422) {
            mensagemErro += "Verifique se todos os dados estão corretos.";
          } else if (error?.response?.status === 400) {
            mensagemErro +=
              "Dados inválidos. Verifique se o pedido não está com aprovação PENDENTE.";
          } else {
            mensagemErro +=
              "Verifique se o preço foi digitado ou se o pedido não está com aprovação PENDENTE";
          }

          $q.notify({
            message: mensagemErro,
            color: "negative",
            timeout: 5000,
          });
        }
      } else {
        disableIncluir.value = false;
      }
    };

    const voltar = async () => {
      manual.value = false;
      getDados();
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => props.selecionados,
      () => {
        produtos.value = props.selecionados;
        setTimeout(() => {
          disableIncluir.value = false;
          validarPrecos();
        }, 50);
      },
      { immediate: true, deep: true }
    );

    watch(
      () =>
        produtos.value.map((produto) => ({
          id: produto.product_id,
          price: produto.price,
          purchase_order_price: produto.purchase_order_price,
        })),
      () => {
        disableIncluir.value = false;

        setTimeout(() => {
          validarPrecos();
        }, 10);
      },
      { deep: true, immediate: true }
    );

    watch(
      () => produtos.value,
      () => {
        disableIncluir.value = false;
      },
      { deep: true, immediate: true }
    );

    watch(
      () => solicitantesValuePre.value,
      (newValue) => {
        const idsPre = newValue.map((value) => value.id);
        const idsFinal = solicitantesValueFinal.value.map((value) => value.id);

        // Adiciona IDs que estão em idsPre e não em idsFinal
        idsPre.forEach((id) => {
          if (!idsFinal.includes(id)) {
            const itemToAdd = newValue.find((item) => item.id === id);
            if (itemToAdd) {
              solicitantesValueFinal.value.push(itemToAdd);
            }
          }
        });

        // Remove IDs que estão em idsFinal e não em idsPre
        idsFinal.forEach((id) => {
          if (
            !idsPre.includes(id) &&
            !solicitantesValue.value.map((value) => value.id).includes(id)
          ) {
            const indexToRemove = solicitantesValueFinal.value.findIndex(
              (item) => item.id === id
            );
            if (indexToRemove !== -1) {
              solicitantesValueFinal.value.splice(indexToRemove, 1);
            }
          }
        });
      },
      { deep: true } // Importante para observar mudanças dentro dos objetos do array
    );

    watch(
      () => solicitantesValue.value,
      (newValue) => {
        // Removido o parâmetro oldValue
        const idsPre = newValue.map((value) => value.id);
        const idsFinal = solicitantesValueFinal.value.map((value) => value.id);

        // Adiciona IDs que estão em idsPre e não em idsFinal
        idsPre.forEach((id) => {
          if (!idsFinal.includes(id)) {
            const itemToAdd = newValue.find((item) => item.id === id);
            if (itemToAdd) {
              solicitantesValueFinal.value.push(itemToAdd);
            }
          }
        });

        // Remove IDs que estão em idsFinal e não em idsPre
        // A remoção agora é feita com base na ordem em idsFinal
        idsFinal.forEach((id) => {
          if (
            !idsPre.includes(id) &&
            !solicitantesValuePre.value.map((value) => value.id).includes(id)
          ) {
            const indexToRemove = solicitantesValueFinal.value.findIndex(
              (item) => item.id === id
            );
            if (indexToRemove !== -1) {
              solicitantesValueFinal.value.splice(indexToRemove, 1);
            }
          }
        });
      },
      { deep: true }
    );

    const getEmpresas = async (val) => {
      try {
        const response = await store.dispatch("compras/providerEmpresas", {
          vendor_id: store.state.org.unidadeData.id,
          page: 1,
          per_page: 8,
          provider: filter.value,
          search: val,
        });

        fornecedoresOptions.value = response.data.results.data;

        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(getEmpresas);

    const getSolicitantes = async (val) => {
      try {
        const response = await store.dispatch("compras/getSolicitantes", {
          vendor_id: store.state.org.unidadeData.id,
          search: val,
          page: 1,
        });

        solicitantesOptions.value = response.data.results.data;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(getSolicitantes);

    const criarPedido = async () => {
      if (!recebimento.value) {
        erroRecebimento.value = true;
        return;
      }
      erroRecebimento.value = false;

      try {
        let fluxo = solicitantesValueFinal.value.map((e) => {
          return { ...e, user_id: e.id };
        });

        await store.dispatch("compras/criarNovo", {
          issue_date: recebimento.value,
          provider_id: fornecedorValue.value,
          billing_date_forecast:
            faturamento.value == "" ? undefined : faturamento.value,
          receipt_date_forecast: recebimento.value,
          fluxo_aprovacao: fluxo,
          vendor_id: store.state.org.unidadeData.id,
          tag_id: urgenciaValue.value,
        });

        $q.notify({
          message: "Criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizar");
        getDados();
        recebimento.value = "";
        fornecedorValue.value = "";
        faturamento.value = "";
        recebimento.value = "";
        solicitantesValue.value = [];
        urgenciaValue.value = "";
        rightDrawerOpen.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro ao criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const botaoDesabilitado = computed(() => {
      return disableIncluir.value;
    });

    const forcarAtualizacaoBotao = () => {
      setTimeout(() => {
        disableIncluir.value = false;
      }, 0);
    };

    const resetarEstadoIncluir = () => {
      disableIncluir.value = false;
    };

    const verificarEResetarEstado = () => {
      disableIncluir.value = false;

      setTimeout(() => {
        if (produtos.value.length > 0) {
          disableIncluir.value = false;
        }
      }, 100);
    };

    const handlePrecoAlterado = () => {
      verificarEResetarEstado();
    };

    const fornecedorSelecionado = computed(() => {
      return fornecedoresOptions.value.find(
        (fornecedor) => fornecedor.id === fornecedorValue.value
      );
    });

    const formatarCnpj = (cnpj) => {
      if (!cnpj) return "";
      return cnpj.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
    };

    return {
      pagination,
      rows,
      disable,
      columns,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      produtos,
      incluir,
      filter,
      manual,
      disableIncluir,
      voltar,
      fornecedoresOptions,
      rightDrawerOpen,
      fornecedorValue,
      solicitantesValue,
      solicitantesOptions,
      faturamento,
      recebimento,
      solicitantesValueFinal,
      erroRecebimento,
      criarPedido,
      columnsModal,
      confirm,
      saveForecastFormatado,
      saveForecast,
      saveForecastOld,
      solicitantesOptionsPre,
      solicitantesValuePre,
      saveRow,
      solicitantesOptionsFinal,
      botaoDesabilitado,
      forcarAtualizacaoBotao,
      resetarEstadoIncluir,
      verificarEResetarEstado,
      handlePrecoAlterado,
      fornecedorSelecionado,
      formatarCnpj,
      formatPreco,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      urgenciaOptions: [
        {
          label: "Normal",
          value: 1,
        },
        {
          label: "Urgente",
          value: 2,
        },
        {
          label: "Máquina Parada",
          value: 3,
        },
      ],
      unidade,
      urgenciaValue,
      filtrarSolicitante(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          getSolicitantes(val);
        }, 500);

        setTimeout(() => {
          update();
        }, 1000);
      },
      filtrarFornecedores(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          getEmpresas(val);
        }, 500);

        setTimeout(() => {
          update();
        }, 1000);
      },
    };
  },
};
</script>

<style>
tbody tr td {
  white-space: pre-wrap;
}
.align {
  align-items: center;
}

.no-wrap {
  flex-wrap: nowrap !important;
}

.target {
  cursor: pointer;
  color: #4a93f8;
}

.my-special-class {
  background-color: #59ac5986 !important;
}
</style>
